import { render, staticRenderFns } from "./ContractorDetails.vue?vue&type=template&id=704866ff&scoped=true&"
import script from "./ContractorDetails.vue?vue&type=script&lang=js&"
export * from "./ContractorDetails.vue?vue&type=script&lang=js&"
import style0 from "./ContractorDetails.vue?vue&type=style&index=0&id=704866ff&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "704866ff",
  null
  
)

export default component.exports